export const isEnabledByEnvAndLeague = (
  league: number,
  authorizedLeague: number[],
) => authorizedLeague.includes(league);
